import CouponPublicShow from './coupon-public-show-controller'

export default CouponPublicShow
